import React from "react";
import Header from "@/components/Header";
import CourseCard from "@/components/CourseCard";
import { COURSES } from "@/data/courseSections";
import { getCoursePath } from "@/lib/utils";

const Home = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      <main className="flex-1 p-8">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">
            IB Course Catalogue
          </h1>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {COURSES.map((course) => {
              return (
                <CourseCard
                  key={course.slug}
                  title={course.title}
                  language="python"
                  iconUrl="/lovable-uploads/3dfd2ff6-1794-4172-8596-75ccf6178375.png"
                  linkUrl={getCoursePath(course.slug)}
                />
              );
            })}
            {/* <CourseCard */}
            {/*   title="DP JavaScript Programming" */}
            {/*   language="javascript" */}
            {/*   iconUrl="/lovable-uploads/710fa54f-3c32-4724-b161-575a6f83a8b4.png" */}
            {/*   locked={true} */}
            {/* /> */}
          </div>
        </div>
      </main>
    </div>
  );
};

export default Home;
